import CollectionCard from 'marketplace-ui-common/collections/components/CollectionCard';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import { useRelevantCollections } from 'marketplace-ui-common/collections/hooks/useRelevantCollections';
import Carousel from 'marketplace-ui-common/components/Carousel';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { getIsInApp } from '../../selectors/app';
import { getThemesStorefrontRoute } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ThemeCollectionsCardGrid() {
  const isInApp = useSelector(getIsInApp);
  const {
    getDisplayedCollections,
    error,
    loading
  } = useRelevantCollections({
    appContext: isInApp ? 'app' : 'public',
    offeringType: 'THEME'
  });
  const {
    maxCardsPerPage
  } = useResponsiveProps({
    maxCardsPerPage: {
      [ScreenSizes.SM]: 1,
      [ScreenSizes.MD]: 2,
      [ScreenSizes.LG]: 3
    }
  });
  const displayedCollections = getDisplayedCollections();
  const collectionCards = useMemo(() => displayedCollections.map(collection => /*#__PURE__*/_jsx(RouterLink, {
    alignItems: "stretch",
    blockSize: "100%",
    display: "flex",
    to: getThemesStorefrontRoute(collection.slug),
    use: "unstyled",
    children: /*#__PURE__*/_jsx(CollectionCard, {
      collection: collection
    })
  }, `collection-${collection.id}`)), [displayedCollections]);
  const requestStatus = loading ? RequestState.PENDING : error ? RequestState.FAILED : RequestState.SUCCEEDED;
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: requestStatus,
    children: /*#__PURE__*/_jsx(Carousel, {
      cards: collectionCards,
      maxCardsPerPage: maxCardsPerPage
    })
  });
}